export * as faFunctions from './fa-functions'
